import { render, staticRenderFns } from "./clone-question-action.vue?vue&type=template&id=63cbf8ec"
import script from "./clone-question-action.vue?vue&type=script&lang=js"
export * from "./clone-question-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports